export default "__VITE_ASSET__311e138c__"